import React, {useEffect, useState} from 'react';
import { Row, Col, Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import MiddlewareLogin from '../../../../routers/MiddlewareLogin';
import DropDownInputCampus from './PlanoEnsino/DropDownInputCampus';
import DropDownInputDisciplinas from './PlanoEnsino/DropDownInputDisciplinas';
import DropDownInputCurso from './PlanoEnsino/DropDownInputCurso';
import DropDownInputBibliotecas from './PlanoEnsino/DropDownInputBibliotecas';
import DropDownInputProfessor from './PlanoEnsino/DropDownInputProfessor';
import { ToastifyHelper } from '../../../../shared/helpers';
import { useAccessibilityContext } from '../../../consulta-acessibilidade/contexts/AccessibilityContext';
import Button from '../../../consulta-acessibilidade/Button';
import { useSearchContext } from '../../../../shared/contexts/SearchContextProvider';

/**
 *
 * @author Renan Salustiano <renan.salustiano@ter.grupomarista.org.br>
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const PesquisaPlanoEnsino = props => {
    const { t } = useTranslation();

    const { instituicao } = props;
    const [curso, setCurso] = useState(null);
    const [disciplina, setDisciplina] = useState(null);
    const [campus, setCampus] = useState(null);
    const [biblioteca, setBiblioteca] = useState(null);
    const [professor, setProfessor] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    const { searchInputRef } = useAccessibilityContext();
    const { search } = useSearchContext();

    useEffect(() => {
        setBiblioteca(null)
    }, [campus]);

    const handleClickSearch = e => {
        e.preventDefault();

        if (professor == null && curso == null && disciplina == null) {
            ToastifyHelper.warning(
                'É necessário selecionar um dos seguintes campos: curso, disciplina ou professor.',
                { toastId: 'toastErrorPlanoEnsino' },
            );
            return;
        }

        const data = [
            {
                key: 'curso',
                value:
                    curso !== null
                        ? curso.originalObject.cod_departamento
                        : null,
            },
            {
                key: 'professor',
                value:
                    professor !== null
                        ? professor.originalObject.nome_pessoa
                        : null,
            },
            {
                key: 'biblioteca',
                value:
                    biblioteca !== null
                        ? biblioteca.originalObject.cod_biblioteca
                        : null,
            },
            {
                key: 'disciplina',
                value:
                    disciplina !== null
                        ? disciplina.originalObject.cod_disciplina
                        : null,
            },
            {
                key: 'campus',
                value:
                    campus !== null ? campus.originalObject.cod_campus : null,
            },
        ].filter(item => item.value !== null);


        let form = {};
        const map = ['um', 'dois', 'tres']

        let columnIndex = 0;
        let searchParams = {};

        form.tipo_termos = 99;


        data.forEach((item) => {
            searchParams[item.key] = item.value;
            if(item.key === 'biblioteca'){
                form.biblioteca = item.value;
            }else if(item.key === 'campus'){
                form.campus = item.value;
            }
            else{
                form[`termo_pesquisa${columnIndex === 0 ? '' : `_${map[columnIndex]}`}`] = item.value
                form[`coluna_${map[columnIndex]}`] = item.key.toUpperCase()
                form[`condicao_${map[columnIndex]}`] = 'AND';
                // eslint-disable-next-line no-plusplus
                columnIndex++;
            }
        })


        const newParams = {
            page: 1,
            perPage: 20,
        }
        searchParams = {
            ...searchParams,
            ...newParams
        }

        form =  {
            ...form,
            ...newParams
        }

        search(form, searchParams)

        // const searchString = searchParams
        //     .map(sp => `${sp.key}=${sp.value}`)
        //     .join('&');
        //
        // console.log(searchParams)
        // /**
        //  * Push de parâmetros para realizar a busca
        //  */
        // history.push({
        //     pathname: location.pathname,
        //     search: `?${searchString}`,
        // });
    };

    return (
        <div className='col-md-11 m-auto'>
            <Row className='mt-3'>
                <Col md="10" xs="12">
                    <Row>
                        <Col md="12">
                            <div className='rotulo'>
                                {t('InformeCurso')}
                            </div>
                            <DropDownInputCurso
                                ref={searchInputRef}
                                setCurso={setCurso}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col md="12">
                            <div className='rotulo'>
                                {t('InformeDisciplina')}
                            </div>
                            <DropDownInputDisciplinas
                                setDisciplina={setDisciplina}
                                codDepartamento={curso?.id}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col md="12">
                            <div className='rotulo'>
                                {t('InformeProfessor')}
                            </div>
                            <DropDownInputProfessor
                                setProfessor={setProfessor}
                            />
                        </Col>
                    </Row>

                    {
                        // Condição para mostrar ou não a input de campus
                        instituicao && instituicao?.usa_campus === 'S' && (
                            <Row>
                                <Col md="12">
                                    <div className='rotulo'>
                                        {t('InformeCampus')}
                                    </div>
                                    <DropDownInputCampus
                                        setCampus={setCampus}
                                    />
                                </Col>
                            </Row>
                        )
                    }

                    <Row>
                        <Col md="12">
                            <div className='rotulo'>
                                {t('Biblioteca')}
                            </div>
                            <DropDownInputBibliotecas
                                setBiblioteca={setBiblioteca}
                                campus={campus}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md="2">
                    <Button
                        onClick={handleClickSearch}
                        title="Pesquisar"
                        icon="search"
                        variant='primeiro ml-0 btn-responsivo mt-3 mt-md-3'
                        type="submit"
                        disabled={props.loading}
                    />
                </Col>
            </Row>
        </div>
    );
};

const mapStateToProps = state => ({
    instituicao: state.instituicao.data,
    formRef: state.pageConfig.formRef,
});

export default connect(mapStateToProps)(
    MiddlewareLogin(PesquisaPlanoEnsino),
);
